'use strict';

var FILE_USAGE = {};

Object.defineProperties(FILE_USAGE, {
  USAGE: {enumerable: true, value: null},
  AVATAR: {enumerable: true, value: 'avatar'},
  GALLERY: {enumerable: true, value: 'gallery'},
  BANNER: {enumerable: true, value: 'banner'}
});

module.exports = FILE_USAGE;


// WEBPACK FOOTER //
// ./src/js/core-utilities/aws-api/FILE_USAGE.js